var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0"},[(_vm.incident.type === 'barnIntervention')?_c('BarnInterventionIncidentEventTriggerDialog',{attrs:{"incident":_vm.incident},on:{"triggerevent":_vm.triggerEvent,"reload":_vm.reload}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }